
import { Link } from 'react-router-dom';

const ApresentacaoPage = () => {
  return (
    <div className="min-h-screen bg-black overflow-x-hidden" style={{ fontFamily: 'Manrope, sans-serif' }}>
      {/* Floating Navigation */}
      <nav className="fixed top-6 left-1/2 transform -translate-x-1/2 z-50 bg-black/80 backdrop-blur-xl border border-yellow-500/30 rounded-full px-8 py-4 transition-all duration-500">
        <div className="flex items-center space-x-8">
          <div className="text-xl font-bold text-yellow-400" style={{ fontFamily: 'Cinzel Decorative, serif' }}>
            DLUXMEN
          </div>
          <div className="hidden lg:flex items-center space-x-6">
            <Link
              to="/"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-home-line"></i>
              <span>Início</span>
            </Link>
            <Link
              to="/apresentacao"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-black bg-yellow-400"
            >
              <i className="ri-play-circle-line"></i>
              <span>Experience</span>
            </Link>
            <Link
              to="/equipe"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-team-line"></i>
              <span>Team</span>
            </Link>
            <Link
              to="/produtos"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-fire-line"></i>
              <span>Produtos</span>
            </Link>
            <Link
              to="/contatos"
              className="flex items-center space-x-2 text-xs font-medium transition-all cursor-pointer whitespace-nowrap px-3 py-2 rounded-full text-gray-300 hover:text-yellow-400 hover:bg-yellow-400/10"
            >
              <i className="ri-phone-line"></i>
              <span>Contact</span>
            </Link>
          </div>
          <button
            onClick={() => window.open('https://wa.me/5511945589527?text=Olá!%20Quero%20conhecer%20os%20produtos%20DLUXMEN', '_blank')}
            className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white px-6 py-2 rounded-full text-sm font-semibold transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer shadow-lg shadow-green-500/25"
          >
            <i className="ri-whatsapp-line"></i>
            <span>WhatsApp</span>
          </button>
        </div>
      </nav>

      {/* Apresentação - Video Experience */}
      <section className="py-32 bg-gradient-to-b from-black via-slate-900 to-black relative overflow-hidden min-h-screen flex items-center">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23D4AF37' fill-opacity='0.1'%3E%3Cpath d='M30 30c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20zm0 0c0 11.046 8.954 20 20 20s20-8.954 20-20-8.954-20-20-20-20 8.954-20 20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
          }}></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-20">
            <div className="inline-flex items-center bg-yellow-400/10 border border-yellow-400/30 rounded-full px-6 py-2 mb-8">
              <i className="ri-play-circle-line text-yellow-400 mr-2"></i>
              <span className="text-yellow-400 text-sm font-medium">EXPERIENCE DLUXMEN</span>
            </div>
            
            <h2 className="text-6xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-300 mb-8" 
                style={{ fontFamily: 'Playfair Display, serif' }}>
              A Experiência DLUXMEN
            </h2>
            
            {/* Cinematic Video Container */}
            <div className="relative max-w-6xl mx-auto mb-20 group">
              <div className="aspect-video bg-gradient-to-br from-emerald-900 via-slate-900 to-yellow-900 rounded-3xl flex items-center justify-center border border-yellow-500/20 overflow-hidden relative">
                <div 
                  className="absolute inset-0 bg-cover bg-center opacity-30 group-hover:opacity-50 transition-opacity duration-500"
                  style={{
                    backgroundImage: `url('https://public.readdy.ai/ai/img_res/51549806b872ff08a932b5eef5cd8681.jpg')`
                  }}
                ></div>
                
                <div className="relative z-10 text-center text-white">
                  <div className="w-24 h-24 bg-yellow-400/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-yellow-400/30 transition-all duration-300 cursor-pointer">
                    <i className="ri-play-fill text-4xl text-yellow-400"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-yellow-400 mb-2">Vídeo Institucional DLUXMEN</h3>
                  <p className="text-emerald-200 max-w-2xl mx-auto">
                    Cada peça nasce de um processo cuidadoso, onde o luxo encontra propósito. 
                    Conheça os bastidores da marca que está redefinindo o luxo masculino no Brasil.
                  </p>
                </div>
                
                {/* Decorative Elements */}
                <div className="absolute top-4 left-4 w-8 h-8 border-l-2 border-t-2 border-yellow-400/30"></div>
                <div className="absolute top-4 right-4 w-8 h-8 border-r-2 border-t-2 border-yellow-400/30"></div>
                <div className="absolute bottom-4 left-4 w-8 h-8 border-l-2 border-b-2 border-yellow-400/30"></div>
                <div className="absolute bottom-4 right-4 w-8 h-8 border-r-2 border-b-2 border-yellow-400/30"></div>
              </div>
            </div>
          </div>
          
          {/* Experience Pillars */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              {
                icon: 'ri-user-star-line',
                title: 'Quem Somos',
                description: 'DLUXMEN nasceu para redefinir o luxo masculino no Brasil. Cada detalhe importa — de empreendedores para empreendedores.',
                gradient: 'from-emerald-600 to-emerald-700'
              },
              {
                icon: 'ri-target-line',
                title: 'Nosso Propósito',
                description: 'Transformar vendedores em marcas. Inspirar empreendedores a viver do próprio estilo e construir seu império.',
                gradient: 'from-yellow-600 to-yellow-700'
              },
              {
                icon: 'ri-diamond-line',
                title: 'A Experiência',
                description: 'Atacado e varejo de alto padrão, vídeos HD, atendimento humano e mentoria gratuita para o seu sucesso.',
                gradient: 'from-emerald-600 to-yellow-600'
              }
            ].map((pillar, index) => (
              <div key={index} className="group relative">
                <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-3xl p-8 border border-yellow-500/10 hover:border-yellow-500/30 transition-all duration-500 h-full">
                  <div className={`w-20 h-20 bg-gradient-to-br ${pillar.gradient} rounded-2xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                    <i className={`${pillar.icon} text-3xl text-white`}></i>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-yellow-400 mb-6 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {pillar.title}
                  </h3>
                  
                  <p className="text-gray-300 text-lg leading-relaxed text-center">
                    {pillar.description}
                  </p>
                  
                  {/* Decorative line */}
                  <div className="w-16 h-px bg-gradient-to-r from-transparent via-yellow-400/50 to-transparent mx-auto mt-6"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sobre - About DLUXMEN */}
      <section className="py-32 bg-gradient-to-b from-black via-emerald-950 to-black relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=luxury%20fashion%20atelier%20workshop%20interior%20with%20premium%20fabric%20rolls%2C%20sophisticated%20textile%20manufacturing%20space%20with%20golden%20lighting%2C%20high-end%20menswear%20production%20facility%20with%20emerald%20and%20gold%20accents%2C%20professional%20fashion%20industry%20workspace%20with%20fabric%20textures&width=1920&height=1080&seq=dluxmen-atelier-about&orientation=landscape')`
            }}
          ></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-6xl mx-auto text-center">
            <div className="inline-flex items-center bg-yellow-400/10 border border-yellow-400/30 rounded-full px-6 py-2 mb-8">
              <i className="ri-building-line text-yellow-400 mr-2"></i>
              <span className="text-yellow-400 text-sm font-medium">NOSSA HISTÓRIA</span>
            </div>
            
            <h2 className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-300 mb-12" 
                style={{ fontFamily: 'Playfair Display, serif' }}>
              DLUXMEN — Mais que um nome,<br />uma história.
            </h2>
            
            <div className="bg-gradient-to-br from-slate-800/30 to-slate-900/30 backdrop-blur-sm rounded-3xl p-12 border border-yellow-500/10 mb-16">
              <p className="text-2xl text-gray-200 leading-relaxed mb-8">
                Fundada no coração do Brás, na Antiga Feirinha da Madrugada,<br />
                DLUXMEN cresceu unindo luxo, autenticidade e acessibilidade.
              </p>
              <p className="text-xl text-emerald-200 leading-relaxed">
                Somos referência nacional em super clones 1.1 e 1.2,<br />
                vestindo empreendedores que constroem seu próprio sucesso.
              </p>
            </div>
            
            {/* Timeline */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {[
                { year: '2020', title: 'Primeira Coleção', desc: 'Início da jornada DLUXMEN' },
                { year: '2022', title: 'Referência no Brás', desc: 'Consolidação no mercado' },
                { year: '2024', title: 'Expansão Nacional', desc: 'Alcance em todo Brasil' },
                { year: '2025', title: 'Experience Collection', desc: 'Nova era do luxo real' }
              ].map((milestone, index) => (
                <div key={index} className="text-center group">
                  <div className="w-20 h-20 bg-gradient-to-br from-yellow-600 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-2xl font-bold text-black">{milestone.year}</span>
                  </div>
                  <h3 className="text-xl font-bold text-yellow-400 mb-3">{milestone.title}</h3>
                  <p className="text-gray-300">{milestone.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-16 border-t border-yellow-500/20 relative overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center">
            <div className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-300 mb-6" 
                 style={{ fontFamily: 'Cinzel Decorative, serif' }}>
              DLUXMEN
            </div>
            <p className="text-gray-400 mb-12 text-lg">
              Experience Collection 2025 — Onde cada detalhe faz diferença.
            </p>
            
            <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-yellow-500/20">
              <p className="text-gray-400 mb-4 md:mb-0">
                © 2025 DLUXMEN. Todos os direitos reservados.
              </p>
              <a 
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition-colors text-sm"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ApresentacaoPage;
